module.exports = __webpack_public_path__ + "static/an-abstract-poem-of-freedom_detail1-2009-2b066453c9d5b9878f2a3afccab19c8b.jpg";